/* tslint:disable */
import {
  TemplateHeader
} from '../index';

declare var Object: any;
export interface TemplateDetailInterface {
  "sfdcId"?: string;
  "Name"?: string;
  "CurrencyIsoCode"?: string;
  "CreatedById"?: string;
  "LastModifiedById"?: string;
  "PgMO_Parent_Milestone_Library__c"?: string;
  "PgMO_Milestone_Library__c"?: string;
  "PgMO_Parent_Task_Library__c"?: string;
  "PgMO_Task_Library__c"?: string;
  "PgMO_Template_Header__c"?: string;
  "Template_Type__c"?: string;
  "Sequence_Number__c"?: number;
  "id"?: number;
  "createdAt"?: Date;
  "updatedAt"?: Date;
  templateHeader?: TemplateHeader;
}

export class TemplateDetail implements TemplateDetailInterface {
  "sfdcId": string;
  "Name": string;
  "CurrencyIsoCode": string;
  "CreatedById": string;
  "LastModifiedById": string;
  "PgMO_Parent_Milestone_Library__c": string;
  "PgMO_Milestone_Library__c": string;
  "PgMO_Parent_Task_Library__c": string;
  "PgMO_Task_Library__c": string;
  "PgMO_Template_Header__c": string;
  "Template_Type__c": string;
  "Sequence_Number__c": number;
  "id": number;
  "createdAt": Date;
  "updatedAt": Date;
  templateHeader: TemplateHeader;
  constructor(data?: TemplateDetailInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `TemplateDetail`.
   */
  public static getModelName() {
    return "TemplateDetail";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of TemplateDetail for dynamic purposes.
  **/
  public static factory(data: TemplateDetailInterface): TemplateDetail{
    return new TemplateDetail(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'TemplateDetail',
      plural: 'TemplateDetails',
      path: 'TemplateDetails',
      idName: 'id',
      properties: {
        "sfdcId": {
          name: 'sfdcId',
          type: 'string'
        },
        "Name": {
          name: 'Name',
          type: 'string'
        },
        "CurrencyIsoCode": {
          name: 'CurrencyIsoCode',
          type: 'string'
        },
        "CreatedById": {
          name: 'CreatedById',
          type: 'string'
        },
        "LastModifiedById": {
          name: 'LastModifiedById',
          type: 'string'
        },
        "PgMO_Parent_Milestone_Library__c": {
          name: 'PgMO_Parent_Milestone_Library__c',
          type: 'string'
        },
        "PgMO_Milestone_Library__c": {
          name: 'PgMO_Milestone_Library__c',
          type: 'string'
        },
        "PgMO_Parent_Task_Library__c": {
          name: 'PgMO_Parent_Task_Library__c',
          type: 'string'
        },
        "PgMO_Task_Library__c": {
          name: 'PgMO_Task_Library__c',
          type: 'string'
        },
        "PgMO_Template_Header__c": {
          name: 'PgMO_Template_Header__c',
          type: 'string'
        },
        "Template_Type__c": {
          name: 'Template_Type__c',
          type: 'string'
        },
        "Sequence_Number__c": {
          name: 'Sequence_Number__c',
          type: 'number'
        },
        "id": {
          name: 'id',
          type: 'number'
        },
        "createdAt": {
          name: 'createdAt',
          type: 'Date'
        },
        "updatedAt": {
          name: 'updatedAt',
          type: 'Date'
        },
      },
      relations: {
        templateHeader: {
          name: 'templateHeader',
          type: 'TemplateHeader',
          model: 'TemplateHeader',
          relationType: 'belongsTo',
                  keyFrom: 'PgMO_Template_Header__c',
          keyTo: 'sfdcId'
        },
      }
    }
  }
}
